var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Tooltip } from '@dixa/lib-shared-habla';
import { analytics } from 'app/utils/segment';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import { actions } from 'components/conversation/actions/conversation';
import { getConversationCloseButtonMode } from 'components/conversation/utils/conversationCloseButton';
import { useCommandHandler } from 'utils/commands';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
const { conversationClose } = actions;
export const ConversationCloseButton = () => {
    const dispatch = useAppDispatch();
    const { conversation, isAssignedToMe, asyncStatus } = useAppSelector((state) => ({
        conversation: state.conversation.metaConversation.conversation,
        isAssignedToMe: state.conversation.metaConversation.isAssignedToMe,
        asyncStatus: state.conversation.asyncStatus,
    }));
    const { is_closed: isClosed, id: csid, status, initial_channel: initialChannel, live_assesment: liveAssessment, } = conversation;
    const isDisabled = isClosed || !isAssignedToMe || csid === null;
    useCommandHandler({
        name: 'conversation:close',
        actionFn: () => {
            if (isDisabled) {
                return;
            }
            closeConversation();
        },
    });
    const closeConversation = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            yield bindActionToPromise(dispatch, conversationClose)({
                csid,
            });
            analytics.conversationClosed({
                location: 'conversation',
                channel: conversation.initial_channel || undefined,
                language: (_a = conversation.attributes) === null || _a === void 0 ? void 0 : _a.language,
                direction: conversation.direction || undefined,
                tags: conversation.tags,
            });
        }
        catch (exception) {
            console.error('conversation close exception', exception);
        }
    });
    const mode = getConversationCloseButtonMode(status, initialChannel, liveAssessment === null || liveAssessment === void 0 ? void 0 : liveAssessment.is_end_user_connected);
    const titles = mode === 'close'
        ? {
            tooltip: 'Close conversation',
            loading: 'Closing...',
            button: isClosed ? 'Closed' : 'Close',
        }
        : {
            tooltip: 'End conversation',
            loading: 'Ending...',
            button: 'End conversation',
        };
    const tooltipContent = (_jsx(CommandKeybindingsTooltipContent, Object.assign({ commandName: "conversation:close" }, { children: titles.tooltip })));
    return (_jsx(Tooltip, Object.assign({ content: tooltipContent, dark: true, disabled: isDisabled }, { children: _jsx(Button, Object.assign({ variant: "secondary", disabled: isDisabled, isLoading: asyncStatus.close === 'loading', loadingIndicator: titles.loading, onClick: closeConversation }, { children: titles.button })) })));
};
